// extracted by mini-css-extract-plugin
module.exports = {"figure":"Video_figure__w3y31","iframeContainer":"Video_iframeContainer__3dAbg","videoDisabled":"Video_videoDisabled__1D_nB"};